<div class="address-lookup-container">

    <div class="report-menu">
        <div class="report-title-with-actions">
            <div class="report-name">
                Address Lookup
            </div>

            <div class="report-menu__actions">
                <button
                        mat-icon-button
                        (click)="closeInsight()"
                        [matTooltip]="'Close'"
                        aria-label="close address lookup"
                        class="report-button"
                >
                    <mat-icon>close</mat-icon>
                </button>
            </div>
        </div>

        <div class="report-subtitle">
            Search for an address to see past visits
        </div>
    </div>

    <div class="map-preview-container">
        <app-map-preview
                [nextContent]="mapContent"
                [mapTitle]="'Address Lookup Map'"
        ></app-map-preview>
    </div>

    <div class="address-lookup-overlay">

        @if (!!selectedAddress) {

            @if (!selectedVisit) {
                <!-- current address with back button -->
                <div class="navigation-container">
                    @if (searchString) {
                        <button mat-icon-button
                                color="accent"
                                (click)="backToAddressList()"
                                [matTooltip]="'Back to address list'"
                        >
                            <mat-icon>arrow_back</mat-icon>
                        </button>
                    } @else {
                        <button mat-icon-button
                                color="accent"
                                (click)="cancelSearch()"
                                [matTooltip]="'New Search'"
                        >
                            <mat-icon>arrow_back</mat-icon>
                        </button>
                    }

                    <div class="selected-address">
                        {{ selectedAddress.formatted_address }}
                    </div>

                    <app-filter-button [appliedFiltersCount]="appliedFiltersCount"
                                       [active]="showingFilterBar"
                                       (toggled)="toggleFilter()"
                    ></app-filter-button>
                </div>

                <!-- address visits -->
                <div class="item-list-wrapper">
                    <app-filter-bar
                            [origin]="'addressLookup'"
                            [showingFilterBar]="showingFilterBar"
                            [useDateFilter]="true"
                            [useVehicleFilter]="true"
                            [useDriverFilter]="true"
                            [defaultDateFilter]="TimeRangeFilter.PAST_90_DAYS"
                            (dateFilterChanged)="onDateFilterChanged($event)"
                            (vehicleFilterChanged)="onVehicleFilterChanged($event)"
                            (driverFilterChanged)="onDriverFilterChanged($event)"
                            (appliedFiltersChanged)="appliedFiltersCount = $event"
                    >
                    </app-filter-bar>
                    @if (!isLoadingVisits() && visitItems !== null) {
                        <div class="item-list">
                            @if (visitItems.length === 0) {
                                <div class="no-visits">No address visits found</div>
                            }
                            @for (visitItem of visitItems; track $index) {
                                <app-action-menu-item-2line style="width: 100%;"
                                                            [input]="visitItem"></app-action-menu-item-2line>
                            }
                        </div>
                    }
                    @if (isLoadingVisits()) {
                        <mat-spinner [diameter]="32" class="visits-error"></mat-spinner>
                    }
                </div>
            }

        } @else {

            <mat-form-field appearance="outline"
                            color="accent"
                            class="search-box-wrapper">
                <mat-icon class="search__icon">
                    search
                </mat-icon>

                <input
                        type="text"
                        placeholder="Enter Address or Click on the map"
                        aria-label="enter address"
                        autocomplete="off"
                        matInput
                        [(ngModel)]="searchString"
                        (ngModelChange)="searchStringChanged()"
                        [disabled]="isLoadingFromQueryParams()"
                />

                @if (!!searchString && searchString.length > 0) {
                    <button mat-icon-button
                            class="clear-button"
                            (click)="cancelSearch()"
                            aria-label="cancel search">
                        <mat-icon>close</mat-icon>
                    </button>
                }
            </mat-form-field>

            <!-- address list -->
            <div class="item-list-wrapper">
                <div class="item-list">
                    @for (addressItem of addressItems; track $index) {
                        <app-action-menu-item style="width: 100%;" [input]="addressItem"></app-action-menu-item>
                    }
                </div>
            </div>
        }


        @if (!!selectedVisit) {
            <!-- current address with back button -->
            <div class="navigation-container">
                <button mat-icon-button
                        color="accent"
                        (click)="backToVisitList()"
                        [matTooltip]="'Back to visit list'"
                >
                    <mat-icon>arrow_back</mat-icon>
                </button>

                <div class="selected-address">
                    <span>{{ selectedVisit.time | date:'medium' }}</span>
                </div>
            </div>
        }

        @if (showPassDetails() && !!selectedVisit && !!selectedBreadcrumb) {
            <div class="pass-detail-wrapper">
                <div class="flex-row align-items-center">
                    <div class="pass-icon-wrapper">
                        <div class="pass-icon"
                             [ngStyle]="{
                            'background': selectedBreadcrumb.id === closestBreadcrumb.id ? MapStyles.ADDRESS_PASS_BREADCRUMB_CLOSEST : MapStyles.ADDRESS_PASS_BREADCRUMB_HIGHLIGHTED
                         }"
                        ></div>
                    </div>

                    <div class="pass-detail">
                        @if (!!(selectedVisit.vehicle?.name)) {
                            <div>{{ selectedVisit.vehicle.name }}</div>
                        }
                        @if (!!(selectedVisit.driver?.familyName)) {
                            <div>{{ selectedVisit.driver.familyName }}</div>
                        }
                        <div>{{ selectedBreadcrumb.time | date:'mediumTime' }}</div>
                        <div>{{ selectedBreadcrumb.speed | speed:useMetricSystem }}</div>
                        <div>{{ selectedBreadcrumb.heading | compass }}</div>

                        @if (!!selectedBreadcrumb && !!selectedVisitValidInputs) {
                            @for (sensorInput of selectedVisitValidInputs; track sensorInput.id) {
                                @if (sensorInput.type === SensorType.PLOW || sensorInput.type === SensorType.PLOW2W) {
                                    <div class="content-row">
                                    <span class="info-name">
                                        {{ !!sensorInput.label ? sensorInput.label : 'Plow' }}:
                                    </span>
                                        <span class="info-value">
                                        {{ sensorInput.bitNumber | plowStatus: selectedBreadcrumb.flags }}
                                    </span>
                                    </div>
                                }
                                @if (sensorInput.type === SensorType.GRANULAR_SPREADER) {
                                    <div class="content-row">
                                    <span class="info-name">
                                        {{ !!sensorInput.label ? sensorInput.label : 'Granular Spreader' }}:
                                    </span>
                                        <span class="info-value">
                                        {{ sensorInput.bitNumber | spreaderStatus: selectedBreadcrumb.flags }}
                                    </span>
                                    </div>
                                }

                                @if (sensorInput.type === SensorType.LIQUID_SPREADER) {
                                    <div class="content-row">
                                        <span class="info-name">
                                            {{ !!sensorInput.label ? sensorInput.label : 'Liquid Spreader' }}:
                                        </span>
                                        <span class="info-value">
                                            {{ sensorInput.bitNumber | spreaderStatus: selectedBreadcrumb.flags }}
                                        </span>
                                    </div>
                                }

                                @if (sensorInput.type === SensorType.MOWER) {
                                    <div class="content-row">
                                    <span class="info-name">
                                        {{ !!sensorInput.label ? sensorInput.label : 'Mower' }}:
                                    </span>
                                        <span class="info-value">
                                        {{ sensorInput.bitNumber | mowerStatus: selectedBreadcrumb.flags }}
                                    </span>
                                    </div>
                                }

                                @if (sensorInput.type === SensorType.SWEEPER) {
                                    <div class="content-row">
                                    <span class="info-name">
                                        {{ !!sensorInput.label ? sensorInput.label : 'Sweeper' }}:
                                    </span>
                                        <span class="info-value">
                                        {{ sensorInput.bitNumber | sweeperStatus: selectedBreadcrumb.flags }}
                                    </span>
                                    </div>
                                }
                            }
                        }
                    </div>
                </div>

                @if (hasFeatureFlag(FeatureFlagEnum.DashCam)) {
                    <div>
                        @if (loadingImage()) {
                            <mat-spinner [diameter]="18"></mat-spinner>
                        }
                        <img
                                style="max-width: 100%"
                                [src]="imageData"
                                [alt]="'dashcam preview'"
                                (error)="onImageError()"
                                (load)="onImageLoad()"
                                [hidden]="imageError || !selectedVisit.vehicle?.cameraConfiguration || !imageData"
                        />
                    </div>
                }
            </div>
        }
    </div>
</div>
